import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Sarah has a unique ability to take incredibly dry compliance requirements and turn them into a product experience that users actually enjoy. She speaks the language of engineering, design, and legal fluently.',
  author: 'David Chen',
  role: 'VP of Engineering',
  company: 'MedTrack'
}, {
  quote: "The most stakeholder-aware PM I've worked with. She doesn't just gather requirements; she aligns entire departments around a unified vision while keeping the customer's needs front and center.",
  author: 'Elena Rodriguez',
  role: 'Chief Compliance Officer',
  company: 'FinanceFlow'
}];
export function Testimonials() {
  return <section className="py-20 md:py-32 bg-warm" data-id="element-98">
      <div className="max-w-6xl mx-auto px-6" data-id="element-99">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-100">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative bg-card p-8 shadow-warm-sm" data-id="element-101">
              <QuoteIcon className="absolute -top-5 -left-3 w-14 h-14 text-accent/25 rotate-180" aria-hidden="true" data-id="element-102" />
              <blockquote className="relative z-10" data-id="element-103">
                <div className="w-12 h-1.5 bg-accent mb-6" aria-hidden="true" data-id="element-104" />
                <p className="text-xl md:text-2xl font-serif text-text-primary leading-relaxed mb-8" data-id="element-105">
                  "{testimonial.quote}"
                </p>
                <footer data-id="element-106">
                  <div className="font-bold text-text-primary" data-id="element-107">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-accent-secondary font-medium" data-id="element-108">
                    {testimonial.role}, {testimonial.company}
                  </div>
                </footer>
              </blockquote>
            </motion.div>)}
        </div>
      </div>
    </section>;
}